export default {
  // 'homeManage.infoPlatform': 'Info platform',
};
